/**
 * The words of the companion's text messages (ADR-142 decisions 5.4, 6.2 and 8.1, PROTOCOL.md 6.94.0 and 6.95.0):
 * `companionSet`, `companionName`, `companionSay` and `companionNaming`. Their field tables are in `text.ts`, which `encodeText` and `parseTextFrame`
 * apply. `companionName` takes the character first-name rules (`names/character-name.ts`); the server adds the word
 * filter and the per-owner uniqueness.
 */

/**
 * The Aethling's companion id, the low four bits of the Companion component's first byte (ADR-142 decision 7.1); 0 is none.
 */
export const COMPANION_AETHLING = 1;

/**
 * The longest `companionSay` line key on the wire.
 */
export const MAX_COMPANION_LINE_CHARS = 64;

/**
 * A `companionSay` line as the wire carries it: the key of a short line in `odyssey-lang`, which the page words, in lower
 * case, digits, dots, underscores and hyphens. A key the page does not hold is a value it words generically, not a
 * malformed frame.
 */
export const COMPANION_LINE_PATTERN = /^[a-z0-9][a-z0-9_.-]{0,63}$/;

/**
 * Where the naming of a companion stands, as `companionNaming` tells its owner (ADR-142 decision 5.4, P2.26-T7): `ask`,
 * the offer accepted and the name asked for; `named`, the name chosen and the join saved; or why a name was refused,
 * with the offer still open: `shape`, out of the first-name rule; `reserved`, holding a staff word; `taken`, the name of
 * another of the same player's companions. `closed` says no naming is open: the conversation ended, the offer no longer
 * holds or the join could not be saved, and nothing was written.
 */
export const COMPANION_NAMING_STATES = Object.freeze(["ask", "named", "shape", "reserved", "taken", "closed"] as const);

/**
 * One state of `COMPANION_NAMING_STATES`.
 */
export type CompanionNamingState = (typeof COMPANION_NAMING_STATES)[number];
